<template>
  <div class="content_w_710 template-container" :id="content.key">
    <div
      class="template-unit"
      v-for="(item, index) in content.content"
      :key="item.key"
      :id="`${content.key}-${index}`"
    >
      <component :is="componentsName[content.type]" :content="item" :canSetWidth="true"></component>
      <!-- <imageUnit :content="item"></imageUnit> -->
    </div>
  </div>
</template>

<script>
/*
板式-2 每行两个展示
*/
import imageUnit from "../unit/image.vue";
import videoUnit from "../unit/video-small.vue";
export default {
  name: "mediaTemplate2",
  components: {
    imageUnit,
    videoUnit,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      componentsName: {
        image: 'imageUnit',
        video: 'videoUnit',
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content_w_710 {
  width: calc(100% - 48rem);
  margin: 0 auto 20px;
}
.template-container{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: flex-end;

  .template-unit{
    width: 49%;
    height: auto;
  }
}
</style>